import { createContext, ReactNode, useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";

export const RoleContext = createContext({
  roles: [] as string[],
});

export function useRoles() {
  const { accounts, instance } = useMsal();

  const [roles, setRoles] = useState<string[]>([]);

  useEffect(() => {
    const activeAccount = instance.getActiveAccount();
    if (!activeAccount) {
      return;
    }

    const { idTokenClaims } = activeAccount;
    const claimRoles = idTokenClaims?.roles as string[];
    setRoles(claimRoles);
  }, [accounts, instance]);

  return { roles };
}

export function RoleProvider({ children }: { children: ReactNode }) {
  return <RoleContext.Provider value={useRoles()}>{children}</RoleContext.Provider>;
}
